import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

// Mounted inside BrowserRouter. Initializes GA4 (if configured) and sends
// exactly one page_view per SPA route change. No-ops when no Measurement ID.
export function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
    trackPageView(window.location.href, document.title);
  }, [location.pathname, location.search]);
  return null;
}
